// Isolated hook for loading workspaces to analysis

import { useMutation } from '@tanstack/react-query';
import { LoadWorkspaceOptions } from '@/types/workspace';
import { workspacesApi } from '@/services/api/workspacesApi';
import { useCurrentUserId } from '@/hooks/useCurrentUserId';

/**
 * Hook for loading a workspace and applying it to current analysis
 */
export function useLoadWorkspaceToAnalysis(workspaceType?: 'weibull' | 'vbl') {
  const userId = useCurrentUserId();

  return useMutation({
    mutationFn: async ({ id, options }: { id: string; options?: LoadWorkspaceOptions }) => {
      const response = await workspacesApi.load(id, options, userId, workspaceType);
      return response;
    },
  });
}
